export default __webpack_public_path__ + "static/media/partner-6-league-of-kingdoms.d5d81505.png";